// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1h0sO","footer":"ModalUpdate_footer__1rrRD"};